import { render, staticRenderFns } from "./OrderDetailItemsToolTip.vue?vue&type=template&id=610300fc&scoped=true&"
import script from "./OrderDetailItemsToolTip.vue?vue&type=script&lang=js&"
export * from "./OrderDetailItemsToolTip.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailItemsToolTip.vue?vue&type=style&index=0&id=610300fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610300fc",
  null
  
)

export default component.exports